import React, { useMemo } from 'react';
import { InputLabel, FormHelperText, FormControl } from '@material-ui/core';

import { colors } from '../../../theme';

export type BaseInputWrapperProps = {
  inputId: string;
  label?: string;
  error: boolean;
  errorMessage: string;
  disabled?: boolean;
  helperText?: string;
  children: React.ReactNode;
  colorLabel?: string;
  additionalMargin?: number;
};

type StyleProps = { [key: string]: string | number };

const BaseInputWrapper = ({
  inputId,
  label = '',
  error,
  errorMessage,
  children,
  helperText = '',
  disabled = false,
  colorLabel,
  additionalMargin,
}: BaseInputWrapperProps): JSX.Element => {
  const usedMargin = additionalMargin || 0;
  const labelStyle: StyleProps = {
    marginLeft: usedMargin,
  };
  const errorStyle: StyleProps = {
    marginLeft: usedMargin,
  };

  if (!error) {
    labelStyle.color =
      colorLabel === colors.madison ? colors.silver : colorLabel;
  }

  const helperTextComponent = useMemo((): JSX.Element => {
    if (errorMessage !== '') {
      return (
        <FormHelperText
          data-testid="base-input-wrapper-helper"
          id={`${inputId}-helper`}
          style={errorStyle}
        >
          {errorMessage}
        </FormHelperText>
      );
    }

    if (helperText !== '') {
      return (
        <FormHelperText
          data-testid="base-input-wrapper-helper"
          id={`${inputId}-helper`}
          style={errorStyle}
        >
          {helperText}
        </FormHelperText>
      );
    }

    return null;
  }, [errorMessage, helperText]);

  return (
    <FormControl data-testid="base-input-wrapper" fullWidth error={error}>
      <InputLabel
        style={labelStyle}
        disabled={disabled}
        data-testid="base-input-wrapper-label"
        htmlFor={inputId}
        shrink
      >
        {label}
      </InputLabel>
      {children}
      {helperTextComponent}
    </FormControl>
  );
};

export default BaseInputWrapper;
